import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { BcDialogService } from '@bancolombia/design-system-web/bc-services';
import { BcAlertComponent } from '@bancolombia/design-system-web/bc-alert';

@Injectable({
  providedIn: 'root'
})
export class NavigationBlockerService {
  constructor(
    private location: Location,
    private router: Router,
    private dialogService: BcDialogService
  ) { }

  bloquearRetroceso(): void {
    history.pushState(null, '', location.href);

    const allowedRoutes = [
      '/simular-ajuste',
      '/detalle-negociacion',
      '/TyC',
      '/correo-confirmacion',
      '/confirmacion-opcion',
      '/error'

    ];

    this.location.subscribe(() => {
      const currentUrl = this.router.url;
      if (currentUrl === '/error') {
        history.pushState(null, '', location.href);
        this.dialogService.open(BcAlertComponent, {
          type: 'error',
          text: 'No puedes volver atrás. Los servicios no están disponibles. Por favor Inténtalo más tarde.',
          timeout: 3000
        });
      } else if (allowedRoutes.some(route => currentUrl.includes(route))) {
        history.pushState(null, '', location.href);
        this.dialogService.open(BcAlertComponent, {
          type: 'warning',
          text: 'Para garantizar una mejor experiencia, esta página no permite volver atrás. Toda la información necesaria está disponible en las próximas secciones.',
          timeout: 3000
        });
      }
    });
  }
}

